// extracted by mini-css-extract-plugin
export default {"data":"styles_data__6Ke5h","choices":"styles_choices__cQ6Uf","customDescription":"styles_customDescription__cliPz"};